import { render, staticRenderFns } from "./qualification_honor.vue?vue&type=template&id=1740a020&scoped=true"
import script from "./qualification_honor.vue?vue&type=script&lang=js"
export * from "./qualification_honor.vue?vue&type=script&lang=js"
import style0 from "./qualification_honor.vue?vue&type=style&index=0&id=1740a020&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740a020",
  null
  
)

export default component.exports